import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const ThreeStarsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.threeStars};
`;

export const StarsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${BaseStyle.Mixins.screenSizes.large} {
        flex-direction: row;
        gap: initial;
    }
`;

export const StarContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    align-items: center;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.gaps.small}
    }
`;

export const StarNumber = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 5px;
    color: ${({ theme }) => theme.Text.primary};
    border-radius: 100px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    background-color: ${({ theme }) => theme.Surface.primary};
    position: absolute;
    margin-top: 45px;
    padding-top: 8px;
    justify-content: center;
    align-items: center;

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['16b']}
        width: 32px;
        height: 32px;
        padding: 8px;
        margin-top: 75px;
        line-height: 13px;
    }
`;

export const StarData = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: column;
    margin: 0;

    ${BaseStyle.Mixins.screenSizes.large} {
        margin: 12px 0;
    }
`;

export const NameContainer = styled.a`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
`;

export const PlayerInfo = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    color: ${({ theme }) => theme.Text.secondary};
`;
